#@import Backbone
#@import CountdownTimer.Model
#@import CountdownTimer.View
#@export CountdownTimer

window.CountdownTimer ?= {}
window.CountdownTimer.current ?= {}

CountdownTimer.init = ({timerData}, done = ->) ->
  endAt = timerData?.expiringSoon?.endAt
  return done() unless endAt

  timerModel = new CountdownTimer.Model
    endAt: endAt

  window.CountdownTimer.current.timerModel = timerModel

  window.CountdownTimer.current.timerView  = new CountdownTimer.View
    model: timerModel
    i18n: I18n.scoped()
    el: timerData?.el

  $ ->
    window.CountdownTimer.current.timerView.render()
    done()
